import { render, staticRenderFns } from "./FullScreenModal.vue?vue&type=template&id=54f656d8&scoped=true"
import script from "./FullScreenModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FullScreenModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FullScreenModal.vue?vue&type=style&index=0&id=54f656d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f656d8",
  null
  
)

export default component.exports